import type { PropsWithChildren } from 'react';
import React, { createContext, useMemo } from 'react';

import type { StageProps } from '../types';

export interface ContextState {
  readonly content: StageProps;
  readonly isHeadless: boolean;
}

export const ContentContext = createContext<ContextState>({} as ContextState);

export interface ContentContextProviderProps {
  readonly content: StageProps;
  readonly isHeadless: boolean;
}

const ContentContextProvider = ({
  children,
  content,
  isHeadless,
}: PropsWithChildren<ContentContextProviderProps>) => {
  const value = useMemo(
    () => ({
      content,
      isHeadless,
    }),
    [content, isHeadless],
  );

  return <ContentContext.Provider value={value}>{children}</ContentContext.Provider>;
};
export default ContentContextProvider;
